import React, { FC } from "react";
import { Address } from "../../../../../infrastructure/http/modules/cart/cart.models";
import EmailInput from "../../../../common/email-input";
import Input from "../../../../common/input";

type Props = {
  fieldName: keyof Address;
  id: string;
  label: string;
  value: string;
  isRequired?: boolean;
  hasError?: boolean;
  displayValidationMessages: boolean;
  onInputValueChange: (name: keyof Address, value: string, isValid: boolean) => void;
};

const AddressInputField: FC<Props> = ({
  fieldName,
  label,
  id,
  isRequired,
  hasError,
  displayValidationMessages,
  value,
  onInputValueChange,
}) => {
  const handleValueChange = (name: string, value: string, isValid: boolean) => {
    onInputValueChange(fieldName, value, isValid);
  };

  if (fieldName === "email") {
    return (
      <li className="input-container">
        <EmailInput
          label={label}
          id={id}
          isRequired={isRequired}
          name={fieldName}
          hasError={hasError}
          showValidationText={displayValidationMessages}
          value={value}
          onValueChange={handleValueChange}
        />
      </li>
    );
  }

  return (
    <li className="input-container">
      <Input
        label={label}
        id={id}
        isRequired={isRequired}
        name={fieldName}
        hasError={hasError}
        showValidationText={displayValidationMessages}
        value={value}
        onValueChange={handleValueChange}
      />
    </li>
  );
};

export default AddressInputField;
